module.exports = __webpack_public_path__ + "static/breastfeeding_img1@2x-0d5f53cae155bc3be547d84276cfa287.png";